export enum CarouselSize {
  NEWS = 'NEWS',
  GRANTS = 'GRANTS',
  HIGHLIGHT = 'HIGHLIGHT',
}
